'use strict'

import axios from 'axios'
import qs from 'qs'
import api from '@/api/index';
import {Message, MessageBox} from 'element-ui'
import {getRefreshToken, getToken} from '@/utils/auth';
import {isEmpty} from '@/utils/filters';
import {removeEnterpriseIsAuth, removeRefreshToken, removeToken, removeUserName, removeRealName, removeUserType} from "./auth";
import router from '../router/index'
import Bus from '../utils/bus';

const BASE_URL = 'pw'
// const BASE_URL = ''
axios.interceptors.request.use(
  config => {
    if (config.method === 'get') {
      config.data = true
    }

    config.headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      // 'Authorization-Ip-Addr': returnCitySN["cip"],
      'Authorization': isEmpty(getToken()) ? '' : getToken(),
      'Authorization-Refresh': isEmpty(getToken()) ? '' : getRefreshToken()
    }
    return config
  }, error => {
    return Promise.reject(error)
  })

axios.interceptors.response.use(response => {
  const status = response.status
  if (status >= 400 || status === 403 || status === 404) {
    Message({ message: '系统繁忙，请稍后再试', type: 'error', duration: 2 * 1000 });
  }
  return response
}, error => {
  if (document.getElementsByClassName('el-message').length === 0) {
    Message({ message: '系统繁忙，请稍后再试' || '请求错误', type: 'error', duration: 2 * 1000 })
  }
  return Promise.resolve(error.response)
})

function checkStatus(response) {
  // loading
  // 如果http状态码正常，则直接返回数据
  if (response && response.data.code === '00000') {
    // this.$message.error('错了哦，这是一条错误消息');
    return response.data;
  } else if (response && (response.data.code === '00010' || response.data.code === '00012')) {
    removeToken();
    removeRefreshToken();
    removeUserType();
    removeUserName();
    removeRealName();
    removeEnterpriseIsAuth();
    Bus.$emit('updateLoginStatus',null);
    router.replace('/');
  } else {
    if (document.getElementsByClassName('el-message').length === 0) {
      Message({
        showClose: true,
        message: response.data.msg,
        type: 'error'
      })
    }
    return
  }
  // // 异常状态下，把错误信息返回去
  // return {
  //   status: -404,
  //   msg: '网络异常'
  // }
}

function checkCode(res) {
  // 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
  if (res.code === -404) {
    alert(res.msg)
  }
  if (res.data && (!res.data.success)) {
    alert(res.data.error_msg)
  }
  return res
}

export default {
  post(url, params) {
    this.methods.addBasicParas(params);
    return axios({
      method: 'post',
      // baseURL: api.apipath,
      baseURL: BASE_URL,
      url,
      data: params,
      timeout: 10000 * 6
    }).then(
      (response) => {
        return response.data
      }
    ).catch(
      (res) => {
        return checkCode(res)
      }
    )
  },
  get(url, params) {
    this.methods.addBasicParas(params);
    return axios({
      method: 'get',
      // baseURL: api.apipath,
      baseURL: BASE_URL,
      url,
      timeout: 10000 * 6
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).catch(
      (res) => {
        return checkCode(res)
      }
    )
  },
  put(url, params) {
    this.methods.addBasicParas(params);
    return axios({
      method: 'put',
      // baseURL: api.apipath,
      baseURL: BASE_URL,
      url,
      data: params,
      timeout: 10000 * 6
    }).then(
      (response) => {
        return response.data
      }
    ).catch(
      (res) => {
        return checkCode(res)
      }
    )
  },
  methods: {
    addBasicParas(params) { // 增加基础参数
      if ('object' == typeof params && params != null) {
        let token = this.getToken();
        if (token && token.length > 0)
          params.token = token;
        // params.sign = this.getSign(params);
      }
    },
    getToken() { // 获取token
      return localStorage.getItem("token");
    },
    getSign() { // 获取签名
      return '';
    },
  }

}



// WEBPACK FOOTER //
// ./src/utils/request.js